import React from 'react'
import { Archive, PencilLine } from '@phosphor-icons/react'
import { Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { infoMessage } from 'api/global'
import { useChangeExternalStatus } from 'api/External/External'
import ButtonSpinner from 'components/global/ButtonSpinner'

interface ManageButtonLeagueProps {
  id: string
  status?: string
}

const ManageButtonExternal: React.FC<ManageButtonLeagueProps> = ({
  id,
  status,
}) => {
  const {
    mutate: changeExternalStatusMutation,
    isLoading: changeExternalStatusMutationLoading,
  } = useChangeExternalStatus()

  const handleArchiveClick = () => {
    const payload = {
      status: status === 'archived' ? 'draft' : 'archived',
    }
    changeExternalStatusMutation({ payload, externalId: id })
  }

  const items = [
    {
      key: 'edit',
      label: (
        <Link to={`/update-external/${id}`}>
          <div
            className="flex align-center"
            onClick={() =>
              infoMessage('External details need to be implemented')
            }
          >
            <PencilLine size={20} color="#000" />
            <h4 className="w-500 text-14 ml-10px">Edit external</h4>
          </div>
        </Link>
      ),
    },
    {
      key: 'archive',
      label: (
        <div className="flex align-center" onClick={handleArchiveClick}>
          <Archive size={20} color="#000" />
          <h4 className="w-500 text-14 ml-10px">
            {status === 'archived' ? 'Unarchive' : 'Archive'} external
          </h4>
        </div>
      ),
    },
  ]

  return (
    <Dropdown
      menu={{
        items: items,
      }}
      placement="bottomLeft"
      arrow={false}
      className="mr-10px "
      overlayStyle={{ width: '250px' }}
    >
      <button className="w-500 prim-sm-btn">
        {changeExternalStatusMutationLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          'Manage external'
        )}
      </button>
    </Dropdown>
  )
}

export default ManageButtonExternal
